export const FIRST_POD_INDEX = 1
export const SECOND_POD_INDEX = 2

interface ElectricityMeterData {
  pdlNo?: string
  meterSerialNumber?: string
  [key: string]: unknown
}

interface ContractAddress {
  electricityMeter?: ElectricityMeterData
  electricityMeter2?: ElectricityMeterData
}

export const hasSecondElectricityMeter = (address: ContractAddress): boolean =>
  Boolean(address.electricityMeter2?.pdlNo || address.electricityMeter2?.meterSerialNumber)

export const contractPodIndex = (address: ContractAddress, podIndex: unknown): number =>
  Number(podIndex) === SECOND_POD_INDEX && hasSecondElectricityMeter(address) ? SECOND_POD_INDEX : FIRST_POD_INDEX

export const contractElectricityMeter = (address: ContractAddress, podIndex: unknown): ElectricityMeterData => {
  if (contractPodIndex(address, podIndex) === SECOND_POD_INDEX) {
    return address.electricityMeter2 ?? {}
  }

  return address.electricityMeter ?? {}
}

export const meterDisplayValue = (meter: ElectricityMeterData, showMeterSerialNumber: boolean): string => {
  if (showMeterSerialNumber && meter.meterSerialNumber) return meter.meterSerialNumber

  return meter.pdlNo ?? ''
}
